import React from 'react'
import {FilePdfOutlined, LoadingOutlined, DeleteFilled} from '@ant-design/icons'
import Button from 'components/shared/Button'

const Preview = ({asset}) => {
  if (asset.__typename === 'DocumentAsset') {
    return (
      <a href={asset.url} target="_blank" rel="noopener noreferrer">
        <FilePdfOutlined />
      </a>
    )
  }
  return (
    <a href={asset.image.url} target="_blank" rel="noopener noreferrer">
      <img src={asset.image.thumbUrl} alt="" />
    </a>
  )
}

const DeletableAssetThumb = ({asset, onDelete, isDeleting}) => {
  const classNames = ['deletable-asset-thumb']
  let Icon = DeleteFilled
  if (isDeleting) {
    classNames.push('deleting')
    Icon = LoadingOutlined
  }

  return (
    <div className={classNames.join(' ')}>
      <span className="inner">
        <Preview asset={asset} />
      </span>
      <span className="actions-overlay">
        <Button
          disabled={isDeleting}
          onClick={onDelete}
        >
          <Icon />
        </Button>
      </span>
    </div>
  )
}

export default DeletableAssetThumb
